import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface TabBarProps {
  defaultValue: string;
  onChangeMod: ( key: string ) => void;
  tabModMap: Map<string, JSX.Element>;
}

export function TabBarComponent( { defaultValue, tabModMap, onChangeMod }: TabBarProps ) {
  const { t } = useTranslation();

  /*----------------------------- useState ------------------------------*/
  const [ seletedTab, setSeletedTab ] = useState<string>( defaultValue );

  /*------------------------------- Front -------------------------------*/
  return (
    <div className='mx-10'>
      <div className='flex flex-row flex-wrap w-[100%] h-fit gap-2 items-center justify-center text-sm font-medium text-gray-900'>
        {
          [ ...tabModMap.keys() ].map( key => {
            return (
              <div
                className={
                  'flex w-[150px] min-w-[75px] h-[40px] items-center px-2 justify-center bg-white-off rounded-t-lg text-gray-900 hover:bg-gray-100 cursor-pointer '
                  + ( seletedTab === key ? 'font-bold border-b-[3px] border-red-base text-[14.5px]' : 'font-medium text-[14px]' )
                }
                key={ key }
                onClick={ () => {
                  setSeletedTab( key );
                  onChangeMod( key );
                } }
              >
                { t( key ) }
              </div>
            );
          } )
        }
      </div>
      <div className='border-t-2 border-gray-100'>
        {
          tabModMap.get( seletedTab )
        }
      </div>
    </div>
  );

}